export const FETCH_STOCK_LOCATION_PENDING = 'FETCH_STOCK_LOCATION_PENDING';
export const FETCH_STOCK_LOCATION_REJECTED = 'FETCH_STOCK_LOCATION_REJECTED';
export const FETCH_STOCK_LOCATION_FULFILLED = 'FETCH_STOCK_LOCATION_FULFILLED';

export const FETCH_ALL_STOCK_LOCATIONS_FULFILLED =
  'FETCH_ALL_STOCK_LOCATIONS_FULFILLED';
export const FETCH_ALL_STOCK_LOCATIONS_REJECTED =
  'FETCH_ALL_STOCK_LOCATIONS_REJECTED';



// WEBPACK FOOTER //
// ./src/constants/stockLocation.js